import { useEffect, useState } from "react";

import { withNamespaces } from "react-i18next";

import { AuthContextValue } from "../../context/AuthContext";
import { GetContextValue } from "../../context/GetContext";
import Loading from "../../components/Loading/Loading";
import useFetch from "../../hooks/UseFetch";
import StandartTable from "../../components/Table/StandartTable/StandartTable";
import ErrorComponent from "../../components/ErrorComponent/ErrorComponent";

function RevisedOpportunities({
  t,
  tableFilter,
  searchText,
  tableRender,
  notificationRender,
}) {
  const { token, loginUserCompanyId } = AuthContextValue();
  const {
    selectValueId,
    setSelectValueId,
    selectValue,
    setSelectValue,
    // notificationRender,
  } = GetContextValue();

  const [revisedOpportunitiesPage, setRevisedOpportunitiesPage] = useState(1);
  const [revisedOpportunitiesRowsPerPage, setRevisedOpportunitiesRowsPerPage] =
    useState(10);

  const opportunitiesStatus = 3;

  const {
    setUseFetchRender: setRevisedOpportunitiesUseFetchRender,
    useFetchRender: revisedOpportunitiesUseFetchRender,
    error: revisedOpportunitiesError,
    loading: revisedOpportunitiesLoading,
    data: revisedOpportunities,
    total: revisedOpportunitiesTotal,
  } = useFetch(
    `${process.env.REACT_APP_GET_TENDER_SUPPLIER_LIST_URL}?SortType=${tableFilter}&Status=${opportunitiesStatus}&CompanyId=${loginUserCompanyId}&Page=${revisedOpportunitiesPage}&PageSize=${revisedOpportunitiesRowsPerPage}`,
    token
  );

  const columns = [
    {
      key: "logo",
      header: t("table_photo"),
    },
    {
      key: "result",
      header: t("table_status"),
    },
    {
      key: "companyName",
      header: t("table_company_name"),
    },
    {
      key: "categories",
      header: t("table_category"),
    },
    {
      key: "productName",
      header: t("table_product"),
    },
    {
      key: "amount",
      header: t("table_amount"),
    },
    {
      key: "distance",
      header: t("table_distance"),
    },
    {
      key: "duration",
      header: t("table_duration"),
    },
    {
      key: "createdAt",
      header: t("table_create_date"),
    },
    {
      key: "remainingTime",
      header: t("table_remaining_time"),
    },
  ];

  useEffect(() => {
    setRevisedOpportunitiesUseFetchRender(!revisedOpportunitiesUseFetchRender);
  }, [tableRender, notificationRender]);

  /* sayfaya girdiğimizde contextte var olan veriyi siler */
  useEffect(() => {
    setSelectValue(null);
    setSelectValueId(null);
  }, []);

  function handleClickValue(valueId, value) {
    setSelectValueId(valueId);
    setSelectValue(value);
  }
  
  return (
    <>
      {revisedOpportunitiesError ? (
        <ErrorComponent error={revisedOpportunitiesError} />
      ) : revisedOpportunitiesLoading ? (
        <Loading />
      ) : revisedOpportunities !== null && revisedOpportunities.length > 0 ? (
        <StandartTable
          type="tender"
          selectValueId={selectValueId}
          selectValue={selectValue}
          handleClickValue={handleClickValue}
          useFetchRender={revisedOpportunitiesUseFetchRender}
          setUseFetchRender={setRevisedOpportunitiesUseFetchRender}
          total={revisedOpportunitiesTotal}
          page={revisedOpportunitiesPage}
          setPage={setRevisedOpportunitiesPage}
          rowsPerPage={revisedOpportunitiesRowsPerPage}
          setRowsPerPage={setRevisedOpportunitiesRowsPerPage}
          columns={columns}
          data={revisedOpportunities}
        />
      ) : (
        <div className="table-null-text">{t("message_no_opportunities")}</div>
      )}
    </>
  );
}

export default withNamespaces()(RevisedOpportunities);
